'use client'
import {useOAuth} from '@/src/features/auth/model/use-oauth'
import {observer} from 'mobx-react'
import * as LoginUI from '../../../ui/login.styled'
import * as VKUI from './btn.styled'
import {OAuthProvider} from '@/src/config/settings'
import {LoadingIcon} from '@/src/shared/ui/icons/loading'

export const VKBtn = observer(() => {
  const {signIn, disabled, loading} = useOAuth({provider: OAuthProvider.VK})

  return (
    <VKUI.LoginButton onClick={signIn} data-disabled={disabled}>
      <LoginUI.LoginButtonInner title="Войти с VK ID">
        <VKUI.Icon width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 10.56C0 5.58197 2.38419e-07 3.09295 1.54648 1.54648C3.09295 0 5.58197 0 10.56 0H11.44C16.418 0 18.907 0 20.4535 1.54648C22 3.09295 22 5.58197 22 10.56V11.44C22 16.418 22 18.907 20.4535 20.4535C18.907 22 16.418 22 11.44 22H10.56C5.58197 22 3.09295 22 1.54648 20.4535C2.38419e-07 18.907 0 16.418 0 11.44V10.56Z"
            fill="#0077FF"
          />
          <path
            d="M11.7067 15.9C6.68424 15.9 3.81956 12.4466 3.7002 6.70001H6.21599C6.29862 10.9178 8.1533 12.7044 9.62238 13.0728V6.70001H11.9913V10.3376C13.4421 10.1811 14.9661 8.52344 15.4802 6.70001H17.8492C17.4544 8.94706 15.8017 10.6047 14.6264 11.2862C15.8017 11.8387 17.684 13.2846 18.4002 15.9H15.7925C15.2324 14.1503 13.8369 12.7965 11.9913 12.6123V15.9H11.7067Z"
            fill="white"
          />
        </VKUI.Icon>
        Войти с VK ID
      </LoginUI.LoginButtonInner>
      {loading && (
        <LoginUI.Loading>
          <LoadingIcon />
        </LoginUI.Loading>
      )}
    </VKUI.LoginButton>
  )
})
